import { SerializedStyles, css } from "@emotion/react";

import Image from "next/image";

import { ButtonWrapper } from "components/shared/library/ButtonWrapper";
import { Typography } from "components/shared/library/Typography";

import { Job } from "apis/jobs";

import { getAvatarPath, getJobsOrgPhotoPath } from "utils/file";

import { purple, uiGray, white } from "constants/colors";
import { placeholderOrgLogo } from "constants/images";

const style = {
  image: css({
    borderRadius: 8,
  }),
  active: css({
    background: purple[200],
    "&:hover": {
      background: purple[200],
    },
  }),
  container: css({
    display: "flex",
    background: white,
    padding: 12,
    width: "-webkit-fill-available",
    gap: 16,
    "&:hover": {
      background: purple[50],
    },
  }),
  info: css({
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
  }),
  xBtn: css({
    height: 25,
  }),
  content: css({
    display: "flex",
    flexDirection: "column",
    gap: 8,
  }),
  imageDiv: css({
    width: 48,
    height: 48,
    minWidth: 48,
  }),
  ellipsis: css({
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
  }),
};

type Props = {
  job: Job;
  isActive?: boolean;
  onClick: () => void;
  customCss?: SerializedStyles;
};

export const JobPreviewCard = ({
  job,
  isActive = false,
  onClick,
  customCss,
}: Props) => {
  return (
    <ButtonWrapper
      onClick={onClick}
      ariaLabel={job.title}
      customCss={[
        style.container,
        isActive ? style.active : undefined,
        customCss,
      ]}
      testId="job-preview-card"
    >
      <div css={style.imageDiv}>
        <Image
          src={
            (job.orgPhotoUrl && getJobsOrgPhotoPath(job.orgPhotoUrl)) ||
            getAvatarPath(placeholderOrgLogo)
          }
          alt="img"
          width={48}
          height={48}
          css={style.image}
        />
      </div>

      <div css={style.content}>
        <div css={style.info}>
          <Typography
            color={purple[800]}
            weight="bold"
            customCss={style.ellipsis}
          >
            {job.title}
          </Typography>
          <Typography size="XS">{job.orgName}</Typography>
          {(job.location || job.modality) && (
            <Typography size="XXS" color={uiGray[70]}>
              {job.location}
              {job.location && job.modality && " "}
              {job.modality && (
                <Typography size="XXS" color={uiGray[70]}>
                  ({job.modality})
                </Typography>
              )}
            </Typography>
          )}
        </div>
        {job.eventType && (
          <Typography size="XXS" weight="bold" color={uiGray[70]}>
            {{ view: "Viewed", save: "Saved", apply: "Applied" }[job.eventType]}
          </Typography>
        )}
      </div>
    </ButtonWrapper>
  );
};
